import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { playSound } from 'containers/App/actions';
import { CLICK_BUTTON_SOUND, HOVER_BUTTON_SOUND } from 'utils/soundConstants';

function createTriggerSoundFactory(triggerSound) {
  return sound => (sound ? () => triggerSound(sound) : undefined);
}

function withSounds({
  mouseEnterSound,
  mouseLeaveSound,
  mouseUpSound,
  mouseDownSound
}) {
  if (true === mouseEnterSound) {
    // Use default hover sound when true.
    mouseEnterSound = HOVER_BUTTON_SOUND;
  }

  if (true === mouseUpSound) {
    // Use default click sound when true.
    mouseUpSound = CLICK_BUTTON_SOUND;
  }

  return function wrapWithSounds(WrappedComponent) {
    class Sounds extends Component {
      render() {
        const { triggerSound, ...otherProps } = this.props;
        const doTriggerSound = createTriggerSoundFactory(triggerSound);

        return (
          <WrappedComponent
            onMouseEnter={doTriggerSound(mouseEnterSound)}
            onMouseLeave={doTriggerSound(mouseLeaveSound)}
            onMouseDown={doTriggerSound(mouseDownSound)}
            onMouseUp={doTriggerSound(mouseUpSound)}
            {...otherProps}
          />
        );
      }
    }

    Sounds.propTypes = {
      triggerSound: PropTypes.func
    };

    function mapDispatchToProps(dispatch) {
      return {
        triggerSound: sound => dispatch(playSound(sound))
      };
    }

    return connect(null, mapDispatchToProps)(Sounds);
  };
}

export default withSounds;
